import * as yup from 'yup'

export const schemaRenewContractModal = yup.object().shape({
    contract_effective_date: yup
        .string()
        .required('Contract effective date is required'),
    contract_expiry_date: yup
        .string()
        .required('Contract expiry date is required'),
    renewal_reason: yup.string().required('Renewal reason is required'),
})
